var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showform)?_c('div',{staticClass:"body-1 pr-4"},[_c('br'),_vm._v(" "+_vm._s(_vm.$t('contacte[0].fraseformulari'))+" "),_vm._v(" "),_c('br')]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }